import { createApp } from "vue"
import { DmkVideoManager } from "../B2bTools";

import html from "./home.html"
import Store from "../Store";

const confDisposition = {
	'd1': [12],
	'd66': [6, 6],
	'd444': [4, 4, 4],
}

const js = ({
	url: function (echangeur) {
		echangeur.addAction('b2b.page.edit', echangeur.hash, '', 'form');
	},
	onLoad: function (echangeur) {

		let THIS = this;
		const videoManager = new DmkVideoManager();

		const form = echangeur.form.doc ? echangeur.form : { doc: {} };

		const app = createApp({
			data: function () {
				return {
					title: form.title,
					id: form.doc._id,
					sections: form.doc.sections,
					v: form.doc.v,
					doc: form.doc,
					arianes: form.arianes,
					pages: form.pages,
					linelists: form.linelists,
					myLinelistIds: form.myLinelistIds, // _id des linelists que cet utilisateur peux ouvrir
					published: form.published,

					// title: echangeur.form.title,
					// id: echangeur.form.doc._id ?? null,
					// sections: echangeur.form.doc.sections,
					// v: echangeur.form.doc.v,
					// doc: echangeur.form.doc,
					// arianes: echangeur.form.arianes,
					// pages: echangeur.form.pages,
					// linelists: echangeur.form.linelists,
					// myLinelistIds: echangeur.form.myLinelistIds, // _id des linelists que cet utilisateur peux ouvrir
					// published: echangeur.form.published,
				}
			},

			methods: {

				gotoAriane(ariane) {
					const p = { page: ariane._id };
					THIS.hashChaine("home", { u: echangeur.hash.u, ...p });
				},

				goToLink(link) {
					if (link.type === 'page') {
						THIS.hashChaine("home", { u: echangeur.hash.u, page: link.page });
					}

					if (link.type === 'linelist') {
						let custom = this.linelists.find(u => u.parent === link.linelist);
						if (this.myLinelistIds.indexOf(link.linelist) >= 0) {
							THIS.hashChaine("linelist", { u: echangeur.hash.u, _id: link.linelist });
						} else if (custom) {
							THIS.hashChaine("linelist", { u: echangeur.hash.u, _id: custom._id });
						} else {
							THIS.hashChaine("env", { u: echangeur.hash.u });
						}
					}
				},

				toCol(col = confDisposition[0]) {
					return confDisposition[col].map(x => 'col-xl-' + x)[0]
				},

				toUrl(media) {
					// const univerTitle = document.querySelector('#univer-title')
					// univerTitle.innerHTML = Store.get('getURUL')();

					//return (media) ? `attachment/page/${this.id}_${media}` : 'assets/img/placeholder.jpg'
					return (media) ? `attachment/page/${this.id}_${media}` : 'assets/img/logo-red.png'
				},

				addVideo(el) {
					videoManager.add(el);
				},

				t(value) {
					return traduit(value, "global");
				}
			},

			mounted() {
				videoManager.whenMounted();
			}

		});

		app.mount(THIS.c$('._vueChargement')[0]);

	},

});

export default {
	home: { js, html }
};
